/**
 * Config statica per `MetricHistoryModal` — una entry per metrica cliccabile
 * da Sforzo (sRPE/ACWR), Recovery (RI) e Readiness (RI/CMJ/HRrest/HRV).
 * Le etichette ricalcano quelle già visibili nelle tabelle (TeamReadinessTab,
 * EffortHeatmapRow, TeamRecoveryView) per coerenza col resto della UI.
 */
export type MetricKey = 'srpe' | 'acwr' | 'ri' | 'cmj' | 'hrv' | 'fcr';

export type MetricChartKind = 'bar' | 'line' | 'acwr';

export interface MetricConfig {
  label: string;
  unit?: string;
  decimals: number;
  chartKind: MetricChartKind;
  /**
   * Colore accento serie/barre — fisso per metrica (badge/legend look, non
   * dipende dal tema). Le parti strutturali del chart (assi/griglia/tooltip)
   * restano invece sui token di `shared/charts/chartTheme` per il dark mode.
   */
  accentColor: string;
}

export const METRIC_CONFIG: Record<MetricKey, MetricConfig> = {
  srpe: { label: 'sRPE', unit: 'AU', decimals: 0, chartKind: 'bar', accentColor: '#5BC9E0' },
  acwr: { label: 'ACWR', decimals: 2, chartKind: 'acwr', accentColor: 'var(--c-text-0)' },
  ri: { label: 'RI (Recovery Index)', unit: '%', decimals: 0, chartKind: 'line', accentColor: 'var(--c-yellow-deep)' },
  cmj: { label: 'CMJ', unit: 'cm', decimals: 1, chartKind: 'line', accentColor: '#5BC9E0' },
  hrv: { label: 'HRV', unit: 'ms', decimals: 0, chartKind: 'line', accentColor: '#9747FF' },
  fcr: { label: 'HRrest (FC a riposo)', unit: 'bpm', decimals: 0, chartKind: 'line', accentColor: '#f57c73' },
};

export const PERIOD_OPTIONS = [
  { value: 7, label: '7G' },
  { value: 30, label: '30G' },
  { value: 90, label: '3M' },
] as const;

export type MetricPeriod = (typeof PERIOD_OPTIONS)[number]['value'];

export const DEFAULT_PERIOD: MetricPeriod = 30;

/** Payload standard del click su una cella-metrica (Sforzo/Recovery/Readiness). */
export interface MetricCellClickParams {
  athleteId: string;
  athleteName: string;
  metric: MetricKey;
  /** YYYY-MM-DD — giorno della cella cliccata */
  highlightDate: string;
}
